module.exports = __webpack_public_path__ + "static/img/2_01.bb6a095.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/junActivity2/2_01.png
// module id = fsKA
// module chunks = 0